import { IconChevronLeft } from '@tabler/icons-react'
import { safeSheetOpenHaptic } from '../lib/safeTelegram'

export default function ScreenShell({ title, onBack, showBackButton = true, titleClassName = '', children }) {
  const handleBack = () => {
    safeSheetOpenHaptic()
    onBack?.()
  }

  return (
    <div className="tma-flow-screen relative flex min-h-0 w-full flex-1 flex-col overflow-hidden">
      {title ? (
        <div className="tma-screen-header relative mb-6 flex h-11 shrink-0 items-center justify-center">
          {showBackButton && onBack ? (
            <button
              type="button"
              onClick={handleBack}
              className="tma-back-button absolute left-0 flex h-11 w-11 shrink-0 items-center justify-center rounded-full active:scale-95"
              aria-label="Назад"
            >
              <IconChevronLeft size={20} stroke={2} />
            </button>
          ) : null}
          <h2 className={`tma-screen-title text-center ${titleClassName}`}>{title}</h2>
        </div>
      ) : null}
      <div className="flex min-h-0 w-full flex-1 flex-col overflow-hidden">{children}</div>
    </div>
  )
}
